export type directionType = "rtl" | "ltr";
export interface IThemeOptions {
  darkMode?: boolean;
  colorPrimary?: string;
  colorAccent?: string;
  colorWarn?: string;
  positionHorizontal?: "left" | "right" | "center";
  positionVertical?: "top" | "bottom";
  direction?: directionType;
  assetPath?: string;
  assets?: string[];
}

export const DEFAULT_THEME_OPTIONS: IThemeOptions = {
  darkMode: false,
  colorPrimary: null,
  colorAccent: null,
  colorWarn: null,
  positionHorizontal: "right",
  positionVertical: "bottom",
  assetPath: null,
  assets: [],
};
